import './components/admin-root/admin-root.js';

console.info('SaaS Admin Panel Initialized');
